import { Button, Paper, useMediaQuery, useTheme } from "@material-ui/core";
import { Document, Page, PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import React from "react";
import { SalesDocument } from "../../../services/SalesDocumentService";
import * as Styles from "../styles/PdfPageStyles";
import { styles } from "../styles/PdfStyles";
import { AddressDetails } from "./PdfAddressDetails";
import { BidsTotals } from "./PdfBidsTotals";
import { BuyerDeclaration } from "./PdfBuyerDeclaration";
import { LogoBanner } from "./PdfLogoBanner";
import { PaymentDetails } from "./PdfPaymentDetails";
import { VehicleDetails } from "./PdfVehicleDetails";

interface PdfProps {
  salesDocumentInfo: SalesDocument;
  loading: boolean;
}

interface MyDocumentProps {
  salesDocumentInfo: SalesDocument
}

const MyDocument: React.FC<MyDocumentProps> = ({ salesDocumentInfo }) => (
  <Document title={salesDocumentInfo.title}>
    <Page size="A4" style={styles.page}>
      <LogoBanner salesDocumentInfo={salesDocumentInfo} />
      <AddressDetails salesDocumentInfo={salesDocumentInfo} />
      <VehicleDetails salesDocumentInfo={salesDocumentInfo} />
      <BidsTotals salesDocumentInfo={salesDocumentInfo} />
      <PaymentDetails salesDocumentInfo={salesDocumentInfo} />
      <BuyerDeclaration />
    </Page>
  </Document>
);

export const Pdf: React.FC<PdfProps> = ({ salesDocumentInfo, loading }) => {
  const classes = Styles.PdfPageStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return loading ? (
    <> </>
  ) : (
    <>
      {isMobile ? (
        <Paper className={classes.container}>
          <h1>Sales Document</h1>
          <p>Please download your sales document below.</p>
          <p> {salesDocumentInfo.title}</p>
          <div style={{ textDecoration: "none" }}>
            <PDFDownloadLink document={<MyDocument salesDocumentInfo={salesDocumentInfo} />} fileName={salesDocumentInfo.title} className={classes.button}>
              {({ loading }) =>
                loading ? (
                  "Loading document..."
                ) : (
                  <Button variant="contained" color="primary">
                    Download
                  </Button>
                )
              }
            </PDFDownloadLink>
          </div>
        </Paper>
      ) : (
        <PDFViewer width="100%" height="1000px">
          <MyDocument salesDocumentInfo={salesDocumentInfo} />
        </PDFViewer>
      )}
    </>
  );
};
